/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */

import {
    AppBar,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    Grid,
    TextField,
    Toolbar,
} from '@material-ui/core';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { esNumerico } from '@infotrack/utilitarios/expresionesRegulares';
import React from 'react';
import { IFormularioBancoVistaProps } from '../interfaces';
const FormularioBancoVista: React.FunctionComponent<IFormularioBancoVistaProps> = ({
    accionCrearEditar,
    cambiarInfoFomulario,
    cerrarFormulario,
    estadoFormulario,
    banco,
    tipoFormulario,
}) => (
    <Dialog open={estadoFormulario}>
        <AppBar position="static">
            <Toolbar>
                <Grid container justifyContent="center">
                    <Texto
                        align="center"
                        color="inherit"
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'banco.agregarBanco'
                                : tipoFormulario === TipoFormulario.Edicion
                                ? 'banco.modificarBanco'
                                : 'banco.verBanco'
                        }
                    />
                </Grid>
            </Toolbar>
        </AppBar>
        <DialogContent>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    {/* hidden={tipoFormulario === TipoFormulario.Creacion? false : true} */}
                    <TextField
                        fullWidth
                        label={<Texto id="banco.codigoBanco" display="inline" />}
                        inputProps={{ readOnly: tipoFormulario === TipoFormulario.Visualizacion }}
                        name="CodigoBanco"
                        onChange={(e) => esNumerico(e.target.value, 8, false) && cambiarInfoFomulario(e)}
                        required
                        value={banco.CodigoBanco}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label={<Texto id="banco.nombreBanco" display="inline" />}
                        inputProps={{ readOnly: tipoFormulario === TipoFormulario.Visualizacion }}
                        name="NombreBanco"
                        onChange={cambiarInfoFomulario}
                        required
                        value={banco.NombreBanco}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={<Checkbox checked={banco.EstadoBanco} onChange={cambiarInfoFomulario} />}
                        label={<Texto id="banco.estadoBanco" display="inline" />}
                        name="EstadoBanco"
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Grid container justifyContent="flex-end" spacing={2}>
                <Grid item>
                    <Button onClick={cerrarFormulario} color="secondary" variant="contained">
                        <Texto id="boton.cancelar" />
                    </Button>
                </Grid>
                <Grid item>
                    <Button onClick={accionCrearEditar} color="primary" variant="contained">
                        <Texto id="boton.guardar" />
                    </Button>
                </Grid>
            </Grid>
        </DialogActions>
    </Dialog>
);

export default FormularioBancoVista;
